import React, { useState } from "react";
import EditFieldModal from "../Edit Field Modal/EditFieldModal";
import { FaSearch } from "react-icons/fa";

export default function GeoDetails({ message }) {
  const countriesList = [
    "India",
    "United States",
    "United Kingdom",
    "Canada",
    "Australia",
    "Germany",
    "France",
    "Japan",
    "China",
    "Brazil",
  ];

  const [geoFields, setGeoFields] = useState({
    country: {
      label: "Country",
      placeholder: "Select your Country",
      type: "required",
    },
    state: {
      label: "State",
      placeholder: "Enter your State",
      type: "required",
    },
    city: {
      label: "City / District",
      placeholder: "Enter your City",
      type: "required",
    },
    locality: {
      label: "Locality",
      placeholder: "Enter your Locality",
      type: "optional",
    },
    street: {
      label: "Street",
      placeholder: "Enter your Street",
      type: "optional",
    },
    pinCode: {
      label: "Pin Code",
      placeholder: "Enter your Pin Code",
      type: "optional",
    },
  });

  const [editingFieldKey, setEditKey] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [addFieldModalOpen, setAddFieldModalOpen] = useState(false);
  const [geoDetailModalOpen, setGeoDetailModalOpen] = useState(false);
  const [selectedFieldType, setSelectedFieldType] = useState(null);

  const handleEditClick = (key) => {
    setEditKey(key);
    setIsModalOpen(true);
  };

  const handleSaveField = (updatedField) => {
    setGeoFields((prev) => ({
      ...prev,
      [editingFieldKey]: updatedField,
    }));
    setIsModalOpen(false);
  };

  const handleFieldChange = (key, newValue) => {
    setGeoFields((prev) => ({
      ...prev,
      [key]: {
        ...prev[key],
        value: newValue,
      },
    }));
  };

  return (
    <div className="p-6 bg-white border-2 border-gray-300 my-5 mx-10 rounded-lg shadow-md w-[72vw]">
      <h2 className="text-xl font-semibold text-gray-800 underline mb-6">
        Geo Details :
      </h2>

      <div className="grid grid-cols-2 gap-8">
        {Object.entries(geoFields).map(([key, field]) => (
          <div key={key} className="flex flex-col">
            <div className="flex items-center justify-between">
              <label className="text-md font-semibold text-gray-600">
                {field.label}
                {field.type === "required" && (
                  <span className="text-red-500">*</span>
                )}
              </label>
              <div className="flex gap-4 text-gray-400 text-lg cursor-pointer">
                {message === "actions not show" ? (
                  <></>
                ) : (
                  <>
                    <span
                      onClick={() => handleEditClick(key)}
                      className="text-gray-400 cursor-pointer"
                    >
                      ✎
                    </span>
                    <span className="text-gray-400 cursor-pointer scale-150">
                      x
                    </span>
                  </>
                )}
              </div>
            </div>

            {key === "country" ? (
              <select
                value={field.value}
                onChange={(e) => handleFieldChange(key, e.target.value)}
                className="mt-1 w-full border border-gray-300 rounded-md px-3 py-2 outline-none"
              >
                <option value="" disabled>
                  {field.placeholder}
                </option>
                {countriesList.map((country) => (
                  <option key={country} value={country}>
                    {country}
                  </option>
                ))}
              </select>
            ) : (
              <input
                type="text"
                placeholder={field.placeholder}
                value={field.value}
                onChange={(e) => handleFieldChange(key, e.target.value)}
                className="mt-1 w-full border border-gray-300 rounded-md px-3 py-2 outline-none"
              />
            )}
          </div>
        ))}
      </div>

      <div className="grid grid-cols-2 items-center px-10 mt-6">
        <div className="flex items-center justify-end">
          <button
            onClick={() => setAddFieldModalOpen(true)}
            className="px-3 py-1 bg-gray-200 font-medium text-gray-600 rounded-md"
          >
            Add Field
          </button>
        </div>
        <div className="flex items-center justify-end">
          <button
            onClick={() => setAddFieldModalOpen(true)}
            className="px-3 py-1 bg-gray-200 font-medium text-gray-600 rounded-md"
          >
            Add Field
          </button>
        </div>
      </div>

      {addFieldModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
          <div className="bg-white w-full h-fit max-w-2xl rounded-lg shadow-lg p-6">
            <div className="flex items-center justify-between mb-5">
              <h1 className="text-xl text-gray-900 font-bold">Add Field</h1>
              <h1
                onClick={() => setAddFieldModalOpen(false)}
                className="text-xl text-gray-900 hover:text-red-600 cursor-pointer font-bold"
              >
                X
              </h1>
            </div>

            <div className="relative">
              <input
                type="text"
                placeholder="Search ..."
                className="w-full border p-2 mb-4 border-gray-300 rounded-md bg-gray-200 text-gray-500 outline-none"
              />
              <FaSearch className="absolute right-3 top-3 text-gray-500" />
            </div>

            <h1 className="decoration-2 text-gray-900 underline underline-offset-4 text-lg my-5">
              Field Types:
            </h1>

            <div className="grid grid-cols-2 gap-3 px-10 mb-5">
              {[
                "Text fields",
                "Radio",
                "Date",
                "Drop Down",
                "Slider",
                "Check Box",
                "Attachment",
              ].map((fieldType) => (
                <label
                  key={fieldType}
                  className="flex items-center text-lg gap-2"
                >
                  <input
                    type="radio"
                    value={fieldType}
                    onChange={() => setSelectedFieldType(fieldType)}
                    checked={selectedFieldType === fieldType}
                  />
                  {fieldType}
                </label>
              ))}
            </div>

            <div className="flex justify-end gap-2 border-t border-gray-300 pt-5">
              <button
                onClick={() => setAddFieldModalOpen(false)}
                className="px-4 py-1 bg-gray-300 rounded"
              >
                Cancel
              </button>
              <button
                onClick={() => {
                  if (selectedFieldType) {
                    setAddFieldModalOpen(false);
                    setGeoDetailModalOpen(true);
                  } else {
                    alert("Please select a field type");
                  }
                }}
                className="px-4 py-1 bg-blue-600 text-white rounded"
              >
                Next
              </button>
            </div>
          </div>
        </div>
      )}

      {geoDetailModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
          <div className="bg-white w-full h-[70vh] max-w-xl rounded-lg shadow-lg p-6">
            <div className="flex items-center justify-between my-5">
              <h1 className="text-xl text-gray-900 font-bold mb-4">
                Geo Details
              </h1>
              <h1
                onClick={() => setGeoDetailModalOpen(false)}
                className="text-xl text-gray-900 hover:text-red-600 cursor-pointer font-bold"
              >
                X
              </h1>
            </div>

            <div className="mb-3 flex items-center justify-between gap-5">
              <div className="flex-1">
                <label className="block text-gray-600 mb-3">
                  Label<span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  placeholder="Enter label name"
                  className="w-full p-2 rounded border border-gray-300"
                />
              </div>
              <div className="flex-2">
                <label className="block text-gray-600 mb-3">
                  Type<span className="text-red-500">*</span>
                </label>
                <select
                  c
                  lassName="w-full border p-2 rounded border border-gray-300"
                >
                  <option>Select</option>
                  <option>Required</option>
                  <option>Non-Required</option>
                </select>
              </div>
            </div>

            {/* <div className="mb-3">
                            <label className="block">Type<span className="text-red-500">*</span></label>
                            <select className="w-full border p-2 rounded" disabled>
                                <option>{selectedFieldType}</option>
                            </select>
                        </div> */}

            <div className="mb-3">
              <label className="block text-gray-600 mb-3">
                Placeholder<span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                placeholder="Enter placeholder"
                className="w-full p-2 rounded border border-gray-300"
              />
            </div>

            {(selectedFieldType === "Drop Down" ||
              selectedFieldType === "Radio" ||
              selectedFieldType === "Check Box") && (
              <div className="mb-3">
                <label className="block text-gray-600 mb-3">
                  Options<span className="text-red-500">*</span>
                </label>
                <textarea
                  placeholder="Enter options separated by commas"
                  className="w-full h-36 p-2 rounded border border-gray-300"
                />
              </div>
            )}

            <div className="flex justify-end gap-2">
              <button
                onClick={() => setGeoDetailModalOpen(false)}
                className="px-4 py-1 bg-blue-600 text-white rounded"
              >
                Add
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal Component */}
      <EditFieldModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        fieldData={editingFieldKey ? geoFields[editingFieldKey] : {}}
        onSave={handleSaveField}
        content={"Geo Details"}
      />
    </div>
  );
}
